import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { catalogueSagaActions } from "..";

import { Button, Card, Carousel, Row  } from "react-bootstrap";

import { ArrowLeftCircleFill, ArrowRightCircleFill } from "react-bootstrap-icons";

import catalogStyles from "../css/Catalogue.module.css";
import carouselStyles from "../css/Carousel.module.css";
import "../css/Generic.css";

export const ProvinceCatalogueCarousel = ({ provinces, provTotalCount }) => {

  const history = useHistory();

  const dispatch = useDispatch();

  let columnCardsCount = 8; //set this to the number cards to be displayed in earch carousel item

  let dummyArray = Array(Math.ceil(provTotalCount / columnCardsCount)).fill(0);

  const handleProvSelection = (province) => {

    dispatch(catalogueSagaActions.setProvince(province));

    history.push({pathname:"/catalogue-management/departments", state: { province }});
  };

  

  return (
    <Carousel
        prevIcon={<ArrowLeftCircleFill className={catalogStyles.carouselNavButton} color="#999" size={40} /> }
        nextIcon={<ArrowRightCircleFill className={catalogStyles.carouselNavButton} color="#999" size={40} /> }
        controls={provTotalCount > columnCardsCount ? true : false}
        indicators={true}
        interval={null} /* set to null to stop carousel from cycling */
      >
        
        { dummyArray.map((val, y) =>  
          <Carousel.Item key={"yyy_" + y}> 
            <Row>
              {provinces.slice(((y)*columnCardsCount),((y+1)*columnCardsCount)).map((prov, z) =>  
                <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-12 d-lg-flex d-md-flex d-sm-flex" key={"zzz_" + z}>
                  <Card  className={`${carouselStyles.carouselCard} w-100 mb-10`}>
                    <Card.Img
                      variant="top"
                      src={prov.flag_image}
                      style={{ width: '100%', height: '40%'}}
                    />
                    <Card.Body className={`${carouselStyles.cardBody}`}>
                      <Card.Title><span style={{fontSize:"1.2rem"}}>{prov.name}</span></Card.Title>
                      <Card.Text>
                        <span style={{fontSize:"1rem", display:"block"}}>View Government services available in this province.</span>
                      </Card.Text>
                      <Button className={`${carouselStyles.cardBodyButton}`} variant="primary" onClick={() => handleProvSelection(prov)}>View Services</Button>
                    </Card.Body>
                  </Card>
                </div>
              )}
            </Row>
          </Carousel.Item>        
        )} 
    </Carousel>
  );
};
